import defaultTheme from './themeDefault';
import clone from 'clone';

const theme = clone(defaultTheme);
theme.palette.primary = { main: '#ff4400'};
theme.palette.secondary = ['#0f0'];
export default theme;



// WEBPACK FOOTER //
// ./src/settings/themes/rentalstep.js